import { supabase } from './api'

export const revalidate = 0

function getCompanyId() {
  return localStorage.getItem("companyId");
}

export async function getAllData() {
  const companyId = getCompanyId();
    const { data, error } = await supabase.from('collegerank').select().eq('companyId',companyId).order('collegename', { ascending: true });
    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  export async function getDataWithType(type) {
    const companyId = getCompanyId();
    const { data, error } = await supabase.from('collegerank').select().eq('companyId',companyId).eq('type',type);

    if (error) {
      throw new Error('Failed to fetch data')
    }
    return data;
  }

  export async function getIdData(id) {
    const companyId = getCompanyId();
    const { data, error } = await supabase.from('collegerank').select().eq('companyId',companyId)
    .eq('id', id);
    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  export async function addData(adata) {
    const companyId = getCompanyId();
    adata = { ...adata, companyId: companyId};

    const { data, error } = await supabase.from('collegerank').insert(adata).select();

    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  export async function updateData(udata) {
    //console.log("udata",udata);
    const { data, error } = await supabase.from('collegerank').update(udata).eq('id', udata.id).select();
    console.log("error",error,data);
    if (error) {

      throw new Error('Failed to fetch data')

    }

    return data;
  }

  export async function deleteIdData(id) {
    const { data, error } = await supabase.from('collegerank').delete()
    .eq('id', id);
    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }
